import React, { useState, useEffect } from "react";
import PrintIcon from "@mui/icons-material/Print";
import { useNavigate } from "react-router-dom";

const PrintOrderDetailNavigator = (props) => {
  const navigate = useNavigate();

  return (
    <>
      <div className="table-icon">
        <PrintIcon
          onClick={() =>
            navigate(`/print-order-details/${props.selectedRow?.id}`, {
              state: {
                see_pre_ordres: props.employeePreOrders ? true : false,
              },
            })
          }
        />
      </div>
    </>
  );
};

export default PrintOrderDetailNavigator;
